export default
{
    /**
     * Generate a new dependency code.
     * The format is 16 digits until ~20 Nov 2286.
     *
     * @returns {number} A random integer prefixed with the current timestamp in ms.
     */
    dependencyCode()
    {
        return Date.now() * 1000 + Math.floor(Math.random() * 1000);
    },
};
